import { render, staticRenderFns } from "./BatchUploadCancel.vue?vue&type=template&id=625bb0ac&scoped=true"
import script from "./BatchUploadCancel.vue?vue&type=script&lang=js"
export * from "./BatchUploadCancel.vue?vue&type=script&lang=js"
import style0 from "./BatchUploadCancel.vue?vue&type=style&index=0&id=625bb0ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625bb0ac",
  null
  
)

export default component.exports